module.exports = __webpack_public_path__ + "static/media/prescriforme.eadeca24.jpg";